// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"121":"gallery","122":"intro","231":"values","611":"roadmap","658":"comics"}[chunkId] + "." + {"121":"d0bd3969","122":"8996b440","231":"3fb5345f","611":"ff2985c7","658":"dc7941f2"}[chunkId] + ".css";
};